import { DetailPanel, type PanelSpan } from '@/components/shared';

export interface MessageBusSummaryTileProps {
  title: string;
  rows: Array<{ label: string; value: string }>;
  span?: PanelSpan;
  currentSpan?: PanelSpan;
  panelId?: string;
}

export function MessageBusSummaryTile({
  title,
  rows,
  span = '2x3',
  currentSpan,
  panelId,
}: MessageBusSummaryTileProps) {
  return (
    <DetailPanel title={title} span={span} currentSpan={currentSpan} panelId={panelId}>
      <dl className="space-y-3 text-body">
        {rows.map((row) => (
          <div
            key={row.label}
            className="grid gap-1 border-b border-neutral-100 pb-3 last:border-b-0 last:pb-0 sm:grid-cols-[10rem_minmax(0,1fr)] sm:gap-4"
          >
            <dt className="font-semibold text-neutral-900">{row.label}</dt>
            <dd className="min-w-0 text-neutral-700">{row.value}</dd>
          </div>
        ))}
      </dl>
    </DetailPanel>
  );
}
